import FingoMuiChip, { highlightedChipStyles } from '../../fingo/components/MuiChip';
import HIGHLIGHTED_CHIP_CLASS_NAME from '../../constants/chip';

const MuiChip = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiChip.styleOverrides.root({ theme }),
      [`&.${HIGHLIGHTED_CHIP_CLASS_NAME}`]: highlightedChipStyles({ theme, backgroundColor: theme.palette.secondary.A400 }),
    }),
  },
};

export default MuiChip;
